@if (this.loadingService.isLoading()) {
<div
  class="fixed inset-0 w-screen h-screen flex items-center justify-center bg-black/40 backdrop-blur-sm z-[10000]"
>
  <div
    class="sm:w-full max-w-sm p-6 rounded-2xl bg-white shadow-xl flex flex-col items-center gap-6 animate-scaleIn dark:bg-gray-700"
  >
    <!-- Spinner -->
    <div class="relative w-24 aspect-square">
      <div class="absolute inset-0 rounded-full border-4 border-gray-300"></div>
      <div
        class="absolute inset-0 rounded-full border-4 border-blue-500 border-t-transparent animate-spin"
      ></div>
    </div>

    <!-- Message -->
    <div
      class="text-2xl font-semibold text-gray-700 dark:text-white flex items-center gap-1 animate-pulse"
    >
      {{ this.loadingService.message() }}
      <span class="bouncing-dots text-nowrap">
        <span class="dot">.</span><span class="dot">.</span
        ><span class="dot">.</span>
      </span>
    </div>
  </div>
</div>
}
